import { useQuery } from '@tanstack/react-query';
import { request } from '../axios';

export interface ValidateDuplicateAddressContactParams {
  firstName: string;
  lastName: string;
}

export interface ValidateDuplicateAddressContactResult {
  firstName: boolean;
  lastName: boolean;
}

export function checkAddressContactDuplicate(params: ValidateDuplicateAddressContactParams) {
  return request<ValidateDuplicateAddressContactResult>({
    url: '/api/addresses/contacts/validate-duplicate',
    method: 'GET',
    params,
  });
}

export function useCheckAddressContactDuplicate(firstName: string, lastName: string, enabled = true) {
  const normalizedFirstName = firstName.trim();
  const normalizedLastName = lastName.trim();

  return useQuery({
    queryKey: ['validate-duplicate-address-contact', normalizedFirstName, normalizedLastName],
    queryFn: () =>
      checkAddressContactDuplicate({
        firstName: normalizedFirstName,
        lastName: normalizedLastName,
      }),
    enabled: enabled && !!normalizedFirstName && !!normalizedLastName,
  });
}
